/* Helper function to determine whether
 * the handoff component should create an
 * internal or external link.
 */

import routeMatcher from './routeMatcher';

export default function isExternalLink(href: any): boolean {
  return typeof href === 'string' ? !routeMatcher(href) : false;
}
